import * as axios from './Axios'

const PREFIX = 'admin/payments'


export const _detailPayment = reference => axios.get(`${PREFIX}/${reference}/detail`)

export const _filterPayments = data => axios.post(`${PREFIX}/filter`, data)


export const _getOrder = number => axios.get(`${number}/amount`)

export const _getBooking = bid => axios.get(`smspay/${bid}`);

export const _asCardPayment = data => axios.post(`booking/cardpayconfirmed`, data)

export const _asCashPayment = data => axios.post(`booking/cardpaycancelled`, data)

export const _getReceipt = (data, reference) => axios.post(`receipt/${reference}`, data)

export const _refundPayment = data => axios.post(`${PREFIX}/refund`, data)


